<template>
  <div>
    <el-popover
      placement="bottom"
      v-model="outer_popover_visible"
      popper-class="profile-menu-popover"
      width="200"
      trigger="click">

      <div v-if="outer_popover_visible">

        <el-popover
          placement="right"
          v-model="popover_visible"
          width="500"
          trigger="hover">

          <div v-if="popover_visible">
            <router-link to="/profile" @click.native="closeProfileMenu(); popover_visible = false;" style="float: right">
              <el-button>
                <font-awesome-icon icon="id-card" />
                Edit Profile
              </el-button>
            </router-link>

            <UserContactDetails :contact-id="$models.user.defaultUserId" :is-myself="true" />
          </div>

          <el-dropdown-item slot="reference" @click.native="outer_popover_visible = popover_visible = false; $router.push('/profile')">
            <font-awesome-icon icon="id-card" />
            <strong>Edit Profile</strong>
          </el-dropdown-item>
        </el-popover>

        <el-popover
          placement="right"
          v-model="lang_popover_visible"
          width="100"
          trigger="hover">

          <div v-if="lang_popover_visible">
            <el-button
              v-for="item in available_languages"
              :key="item.value"
              @click="changeLanguageAndRegion( item.value )">
              <span class="lang-icon">{{ item.icon }}</span>
              &emsp;
              <span>{{ item.label }}</span>
            </el-button>
          </div>

          <el-dropdown-item
            slot="reference"
            @click.native="lang_popover_visible = !lang_popover_visible">
            <font-awesome-icon icon="language" />
            Language
            <span class="lang-icon">({{ langIcon }})</span>
          </el-dropdown-item>
        </el-popover>

        <el-dropdown-item @click.native.prevent="showTimePrefModal" divided>
          <font-awesome-icon icon="pause" />
          Pause Settings
        </el-dropdown-item>

        <el-dropdown-item @click.native.prevent="showBackgroundModal">
          <font-awesome-icon icon="image" />
          Change Background
        </el-dropdown-item>

        <el-dropdown-item @click.native.prevent="showConnectionModal">
          <font-awesome-icon icon="plug" />
          Setup Connections
        </el-dropdown-item>

        <screenfull fill="black" />

        <!--
        <el-dropdown-item @click.native.prevent="showGoalSelectionModal" divided>
          <font-awesome-icon icon="bullseye" />
          Select goals
        </el-dropdown-item>
        -->

        <el-dropdown-item @click.native="$router.push('/terms-and-privacy')" divided>
          <font-awesome-icon icon="info" />
          Terms and privacy
        </el-dropdown-item>

        <el-dropdown-item @click.native="closeProfileMenu; $router.push('/help')">
          <font-awesome-icon icon="question-circle" />
          Help
        </el-dropdown-item>

        <!--
        <el-dropdown-item @click.prevent="help">
          <i class="dropdown-icon fe fe-help-circle"></i> Keyboard Shortcuts
        </el-dropdown-item>
        -->

        <el-dropdown-item @click.native.prevent="onLogout" divided>
          <font-awesome-icon icon="sign-out-alt" />
          Log out
        </el-dropdown-item>

        <template v-if="!is_production && false">
          <div class="dropdown-divider"></div>

          <div class="text-center">DEV</div>

          <el-dropdown-item @click.prevent="showCommitmentModal">
            <i class="dropdown-icon fe fe-clock"></i> Change available time
          </el-dropdown-item>
          <el-dropdown-item @click.prevent="showIdolSelectionModal">
            <i class="dropdown-icon fe fe-users"></i> Select idols
          </el-dropdown-item>
        </template>
      </div>

      <div
        slot="reference"
        :class="{
          'clickable': true,
          'sidebar-contact': true,
        }">

        <a @click.prevent="toggleProfileMenu" style="width: 40px">
          <span class="avatar" :style="{backgroundImage: 'url(&quot;'+profile_pic+'&quot;)'}"></span>
        </a>

        <div class="sidebar-contact__text">{{contactStatus.displayName}}</div>

      </div>
    </el-popover>
  </div>
</template>

<script>
import UserContactDetails from '@/components/Elements/UserContactDetails'
import Screenfull from './Screenfull'
import { availableLanguages } from '@/i18n/available-languages'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      is_production: process.env.VUE_APP_PRODUCTION !== "false",
      available_languages: availableLanguages,
      popover_visible: false,
      outer_popover_visible: false,
      lang_popover_visible: false,
    }
  },
  computed: {
    ...mapGetters('app', ['active_topbar_menu']),
    ...mapGetters("user", [
      "userAuth",
      "userData",
      "loggedIn",
    ]),

    contactStatus() {
      return this.$models.userContact.get_contact_by_id( this.$models.user.defaultUserId ) || {
        displayName: 'loading...'
      }
    },

    profile_pic() {
      return this.$options.filters.defaultUserPic(this.contactStatus.profilePic)
      // TODO:
      // return this.$models.userSettings.getters.get_profile_pic;
    },

    langIcon() {
      if ( this.userData && this.userData.settings && this.userData.settings.language ) {
        let lang = availableLanguages.find(lang => lang.value.toLowerCase() === this.userData.settings.language.toLowerCase());
        return lang ? lang.icon : this.userData.settings.language;
      }
      return '?';
    }
  },
  methods: {
    ...mapMutations('app', ['SET_ACTIVE_TOPBAR_MENU']),

    toggleProfileMenu() {
      this.active_topbar_menu === 'profile'
        ? this.SET_ACTIVE_TOPBAR_MENU(null)
        : this.SET_ACTIVE_TOPBAR_MENU('profile');
    },

    closeProfileMenu() {
      this.SET_ACTIVE_TOPBAR_MENU(null);
    },

    onLogout() {
      this.$api.auth_logout();
      this.$router.push('/login')
    },

    changeLanguageAndRegion(command) {
      this.$api.user_update_language({ language: command });
    },

    showCommitmentModal() {
      this.$root.showModal('timecommitment').then(this.closeProfileMenu);
    },

    showConnectionModal() {
      this.$root.showModal('connection').then(this.closeProfileMenu);
    },

    showGoalSelectionModal() {
      // TODO: Show first page from wizard !!!!
      this.$root.showModal('goalselection').then(this.closeProfileMenu);
    },

    // showHelpModal() {
    //   this.$root.showModal('help').then(this.closeProfileMenu);
    // },

    showIdolSelectionModal() {
      this.$root.showModal('idolselection').then(this.closeProfileMenu);
    },

    showTimePrefModal() {
      this.$root.showModal('timepref').then(this.closeProfileMenu);
    },

    showBackgroundModal() {
      this.$root.showModal('background').then(this.closeProfileMenu);
    },
  },
  components: {
    Screenfull,
    UserContactDetails,
  }
}
</script>
